import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Heroheader from "./sections/Heroheader";
import Introcommitmentbox from "./sections/Introcommitmentbox";
import Quickreferencestrip from "./sections/Quickreferencestrip";
import Privacypolicycontent from "./sections/Privacypolicycontent";
import Thirdpartyservicestable from "./sections/Thirdpartyservicestable";
import Closingcontactstrip from "./sections/Closingcontactstrip";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <Heroheader />
      <Introcommitmentbox />
      <Quickreferencestrip />
      <Privacypolicycontent />
      <Thirdpartyservicestable />
      <Closingcontactstrip />
      <Footer />
    </div>;
}